module.exports = __webpack_public_path__ + "media/images/certificate-2c6e7569c109928794279878bfec6cd2.png";